import script from "./itemV3StonesPosition.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3StonesPosition.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__